export default __webpack_public_path__ + "static/media/036-chicken legs.19d9da2b.svg";